import { Parameters } from "../../Parameters";
import { IParameterRenderer, IParamView, ParameterOwnerModel, RenderParamLabSettingsProps } from "../../ParameterRendererAbstracts";
import React from "react";
import { CaseRunCalculateModel, CaseRunCreateModelBase, RunParameterModel } from "@app/api2/api";
import { ICreateRenderer } from "../../CaseRunCreate";
import { CustomScalingParameterEditor } from "./CustomScalingParameterEditor";
export class IntegralHandler implements IParameterRenderer, ICreateRenderer<CaseRunCreateModelBase, any> {
    propsComplete: (model: CaseRunCreateModelBase | any) => void;
    createBlankModel(props: { labId: number; caseId: number; runType: string; evidenceId?: number; ednaTestId?: number }): Promise<CaseRunCreateModelBase> {
        return null;
    }
    renderInformation(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any, rangeOfContributors: boolean) {
        return null;
    }
    renderReview(model: CaseRunCreateModelBase, onComplete: (values: any) => void, router: any) {
        return null;
    }
    save(props: { labId: number; caseId: number; model: CaseRunCreateModelBase; }) {
        return null;
    }
    applyInformationValuesToModel: (model: CaseRunCreateModelBase, values: any) => CaseRunCreateModelBase;
    renderResults?: (props: { labId: number; caseId: number; caseRunId: number; }) => React.ReactElement;
    renderRunList?: (props: { canCreateEvidence?: boolean; labId: number; caseId: number; }) => React.ReactElement;
    cloneCaseRun?: (props: { labId: number; caseId: number; copyFrom: number; }) => Promise<CaseRunCreateModelBase>;
    runType: string = "integral";

    canHandle(runType: string): boolean {
        return runType == this.runType;
    }

    canRenderParameter(parameterName: string): boolean {
        return parameterName == "intCustomScalingHpBounds" || parameterName == "intCustomScalingHdBounds";
    }
    renderParameterEditor(model: CaseRunCreateModelBase | CaseRunCalculateModel, p: RunParameterModel, values: any, onChange: any, errors: any, setFieldValue: any, parameters: Parameters): JSX.Element {
        var useDeg = model.parameters.find(x => x.parameter == "useDegradation")?.value == "1";
        var useSt = model.parameters.find(x => x.parameter == "useStutter")?.value == "1";
        var useFwSt = model.parameters.find(x => x.parameter == "useFwStutter")?.value == "1";

        return <CustomScalingParameterEditor labId={model.labId} caseId={model.efmCaseId} value={values[p.parameter]} onChange={(vals) => { onChange(p, vals) }} useDeg={useDeg} useBwSt={useSt} useFwSt={useFwSt}  />;
    }
    renderParameterView(p: { model: ParameterOwnerModel; p: IParamView; }): JSX.Element {
        var useDeg = p.model.parameters.find(x => x.parameter == "useDegradation")?.value == "1";
        var useSt = p.model.parameters.find(x => x.parameter == "useStutter")?.value == "1";
        var useFwSt = p.model.parameters.find(x => x.parameter == "useFwStutter")?.value == "1";

        return <CustomScalingParameterEditor labId={p.model.labId} caseId={p.model.efmCaseId} value={p.p.value} readonly={true} useDeg={useDeg} useBwSt={useSt} useFwSt={useFwSt} />;
    }
    renderParameterLabSettings?(p: RenderParamLabSettingsProps): JSX.Element {
        return null;
    }
    // onParameterValueChange?: (p: RunParameterModel, newValue: any, setFieldValue: any, parameters: Parameters) => void;





}
